import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private _router: Router, private _authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    const currentUser = this._authService.getCurrentUser();

    if (!currentUser?.jwt_refresh || this._authService.isTokenExpired(currentUser.jwt_refresh)) {
      console.warn('[AUTH GUARD] Refresh token expired, clearing local session...');
      this._authService.clearExpiredSession(false);
      return this._router.createUrlTree(['/auth/login']);
    }

    if (!currentUser.jwt || this._authService.isTokenExpired(currentUser.jwt)) {
      console.warn('[AUTH GUARD] Access token expired, refreshing before route activation...');

      return this._authService.refreshToken().pipe(
        map((jwt) => {
          if (jwt) {
            return true;
          }

          this._authService.clearExpiredSession(false);
          return this._router.createUrlTree(['/auth/login']);
        }),
        catchError(() => {
          this._authService.clearExpiredSession(false);
          return of(this._router.createUrlTree(['/auth/login']));
        })
      );
    }

    if (currentUser) {
      return true;
    }

    this._authService.clearExpiredSession(false);
    return this._router.createUrlTree(['/auth/login']);
  }
}
